import Vue from 'vue';
import store from './../../store';

// When the request succeeds
const success = (data, context) => {
  const userData = {
    id: data.account.id,
    name: `${data.account.first_name} ${data.account.last_name}`,
    username: data.account.username,
    first_name: data.account.first_name,
    last_name: data.account.last_name,
    role_id: data.account.role_id,
    user_email: data.account.email,
    userId: data.account.id,
    created_at: data.account.created_at,
    phone: data.account.phone,
    number_of_rentals: data.account.number_of_rentals,
    address: data.account.address,
    country_id: data.account.country_id,
    parent_id: data.account.parent_id,
    is_team_member: data.account.is_team_member,
    notes: data.account.notes,
    plan_id: data.account.plan_id,
    currency_id: data.account.currency_id,
    beds24_role: data.account.beds24_role,
    isSyncInProgress: data.account.isSyncInProgress,
    association_code: data.account.association_code,
    zip_code: data.account.zip_code,
    city: data.account.city,
    avatar: data.account.avatar,
    active: data.account.active,
    confirmed: data.account.confirmed,
    onBoarding: data.account.onBoarding,
    onboarding_step: data.account.onboarding_step,
    lang: data.account.lang,
    stripe_id: data.account.stripe_id,
    stripe_card_id: data.account.stripe_card_id,
    prelaunched_at: data.account.prelaunched_at,
    trial_period: data.account.trial_period,
    last_sync_time: data.account.last_sync_time,
    last_login: data.account.last_login,
  };

  localStorage.setItem('user_data', JSON.stringify(userData));
  localStorage.setItem('role_id', userData.role_id);

  mixpanel.identify(data.account.email);
  mixpanel.track('web.login');

  store.dispatch('login', data);
  if (data.account.role_id === 1) {
    Vue.router.push({
      name: 'admin.index',
    });
  } else if (data.first_page && data.first_page !== 'calendar') {
    if (data.first_page === 'analytics') {
      Vue.router.push({
        name: 'analytics.general.tab',
        params: { tab: 'general' },
      });
    } else if (data.first_page === 'autoactions') {
      Vue.router.push({
        name: 'automation.index',
      });
    } else {
      Vue.router.push({
        name: `${data.first_page}.index`,
      });
    }
  } else {
    let calendarPage = 'annual';
    if (data.account.id) {
      calendarPage = localStorage.getItem(`calendar_page_type_${data.account.id}`) ? localStorage.getItem(`calendar_page_type_${data.account.id}`) : 'month';
    }
    Vue.router.push({
      name: 'calendar.type',
      params: { type: calendarPage },
    });
  }
  context.smallLoading = false;

  // let useragentid = null;
  // const OneSignal = window.OneSignal || [];
  // OneSignal.push(() => {
  //   OneSignal.init({
  //     appId: '47128bca-7100-4d3f-a738-2562097c191f',
  //   });
  //   OneSignal.on('subscriptionChange', (isSubscribed) => {
  //     // console.log("The user's subscription state is now:", isSubscribed);
  //     // OneSignal.getUserId(function(userId) {
  //     //   console.log("OneSignal User ID:", userId);
  //     //   // accountService.setOneSignalPlayerId(vm, { onesignal_player_id: userId });
  //     // });
  //     OneSignal.getUserId().then((userId) => {
  //       // console.log("OneSignal User ID:", userId);
  //       useragentid = userId;
  //     }).then(() => {
  //       // this is custom function
  //       // here you can send post request to php file as well.
  //       // console.log("useragentid:", useragentid);
  //       accountService.setOneSignalPlayerId(context, { onesignal_player_id: useragentid });
  //     });
  //   });
  // });
};

// When the request fails
const failed = (context, error) => {
  context.smallLoading = false;
  toastr.error(context.$t('login.wrong_credentials'));
};

export default (user, context) => {
  Vue.$http.post('/user/login', user)
    .then((response) => {
      if (typeof (response) === 'undefined') {
        failed(context);
      } else if (response.status === 200) {
        success(response.data, context);
      } else {
        failed(context);
      }
    })
    .catch((error) => {
      if (error) {
        failed(context, error);
      }
    });
};



// WEBPACK FOOTER //
// ./src/app/services/auth/login.js